var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('main-page'),_c('video-twitch'),_c('sorteio'),_c('transporte'),_c('schedule'),_c('informs'),_c('video-trailer'),_c('ConfirmedTeams'),_c('feedback'),_c('support')],1)}
var staticRenderFns = []

export { render, staticRenderFns }